import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { Manager, useInvalidateManagers } from './get-managers'

export type CreateManagerRequest = {
  avatar?: File
  email: string
  firstName: string
  lastName: string
}

export const createManager = async (data: CreateManagerRequest) => {
  const response = await authAPI.post<Manager>('/manager', composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

export const useCreateManager = () => {
  const invalidateManagers = useInvalidateManagers()

  return useMutation({
    mutationFn: createManager,
    onSuccess: invalidateManagers,
  })
}
